// Timer and label helpers for the moderation command center's live refresh and
// the sidebar badge. Everything about the feed's content — which rows are new,
// filtering, verdicts, the review order, counts and waiting times — comes from
// the server (AdminSite::ModerationController); this only drives the clock.

export const POLL_INTERVAL_MS = 60_000
// A tab left open overnight stops refreshing on its own; Refresh re-engages it.
export const AUTO_STOP_AFTER_MS = 10 * 60 * 60 * 1000
export const NEW_ROW_FLASH_MS = 4000
export const SCROLLED_DOWN_PX = 40
export const RING_TICK_MS = 200
export const RING_FLASH_MS = 600
export const BADGE_CAP = 99

// Gates both the interval tick and the catch-up when a hidden tab comes back.
export const shouldPoll = ({ hidden, paused, idle }) => !hidden && !paused && !idle

export const autoStopDue = (engagedAtMs, nowMs = Date.now()) => nowMs - engagedAtMs >= AUTO_STOP_AFTER_MS

export const liveLabel = ({ paused, idle }) => (paused ? 'Paused' : idle ? 'Idle' : 'Live')

export const refreshLabel = ({ refreshing, paused, idle }) =>
  refreshing ? 'Refreshing' : idle && !paused ? 'Resume refresh' : 'Refresh'

export const ringProgress = (receivedAtMs, nowMs = Date.now()) =>
  receivedAtMs === null ? 0 : Math.min(1, Math.max(0, (nowMs - receivedAtMs) / POLL_INTERVAL_MS))

export const ringSecondsLeft = (progress) => Math.max(0, Math.ceil(((1 - progress) * POLL_INTERVAL_MS) / 1000))

export const badgeLabel = (count) => (count > BADGE_CAP ? `${BADGE_CAP}+` : String(count))

// Rows about the same submission, moment or user share one in-flight guard.
export const subjectKey = (event) => {
  if (event.quest_submission) return `submission:${event.quest_submission.id}`
  if (event.moment) return `moment:${event.moment.id}`
  if (event.user) return `user:${event.user.id}`
  return null
}
